import store from '@/store'
import lang from '@/lang'
import auth from "@/auth";

export default {
  path: '/event/:eventId',
  components: {
    default: () => import(/* webpackChunkName: "event" */ '@/components/wrapper.vue'),
    menu: () => import(/* webpackChunkName: "event" */ './menu.vue'),
  },
  meta: {
    section: 'event'
  },
  beforeEnter: function (to, from, next) {
    if (! auth.checkAccess('event', ['organiser'])) {
      return next(store.state.user.homepage)
    }

    const eventId = to.params.eventId

    const eFilter = {eventId}
    store.dispatch('events.getById', eFilter).then(() => {
      const event = store.state.events.current

      Promise.all([
        store.dispatch('organisations.getById', event.organisationId),
        store.dispatch('eventDisciplines.get', eFilter),
        store.dispatch('clubs.get', eFilter),
        store.dispatch('members.get', eFilter),
        store.dispatch('groups.get', eFilter),
        store.dispatch('teams.get', eFilter),
        store.dispatch('environment.setTitle', (event.titleShort || event.title)),
      ]).then(() => {
        // switch to event language
        const event = store.state.events.current
        if (event.language) {
          lang.setLocale(event.language)
        }

        next()
      })
    })
  },
  children: [
    {
      path: '/',
      name: 'event.view',
      component: () => import(/* webpackChunkName: "event" */ './view.vue'),
    },
    require('./clubs/routes.js').default,
    require('./display/routes.js').default,
    require('./login/routes.js').default,
    {
      path: 'discipline/add',
      name: 'event.discipline.add',
      component: () => import(/* webpackChunkName: "event" */ './event-discipline/add.vue'),
      beforeEnter: function (to, from, next) {
        store.dispatch('disciplines.get').then(
          () => next()
        )
      },
    },
    {
      path: 'discdummy/:disciplineId',
      name: 'event.discipline.dummy',
      component: () => import(/* webpackChunkName: "event" */ './event-discipline/dummy.vue'),
    },
    {
      path: 'discipline/:disciplineId',
      component: () => import(/* webpackChunkName: "event" */ './event-discipline/wrapper.vue'),
      beforeEnter: function (to, from, next) {
        const dFilter = {eventDisciplineId: to.params.disciplineId};
        Promise.all([
          store.dispatch("exercises.get", dFilter),
          store.dispatch("eventDiscipline.get", dFilter),
          store.dispatch("categories.get", dFilter),
          store.dispatch("sessions.getByDiscipline", dFilter),
          store.dispatch("participations.get", dFilter),
          store.dispatch("blocks.get", dFilter),
          store.dispatch("blockParticipations.get", dFilter),
          store.dispatch("rankings.get", dFilter),
        ]).then(() => {
          const ed = store.state.eventDisciplines.items.find(e => e.id === to.params.disciplineId)
          document.title = (ed.shortName || ed.name) + ' - ScoreExpress'
          next()
        }).catch(reason => {
          console.log(reason)
        })
      },
      children: [{
        path: '/',
        name: 'event.discipline',
        component: () => import(/* webpackChunkName: "event" */ './event-discipline/dummy.vue'),
      },
        require('./dashboard/routes.js').default,
        {
          path: 'settings',
          name: 'event.discipline.settings',
          component: () => import(/* webpackChunkName: "event" */ './event-discipline/view.vue'),
        }, {
          path: 'rounds',
          name: 'event.discipline.rounds',
          component: () => import(/* webpackChunkName: "event" */ './event-discipline/rounds.vue'),
        },
        require('./categories/routes.js').default,
        require('./sessions/routes.js').default,
        require('./participants/routes.js').default,
        require('./results/routes.js').default,
        require('./scoreinput/routes.js').default,
        require('./import/routes.js').default,
        {
          path: 'displayControl',
          name: 'event.discipline.displayControl',
          beforeEnter: function (to, from, next) {
            store.dispatch("displays.load", {
              eventId: to.params.eventId
            }).then(() => {
              next();
            });
          },
          component: () => import(/* webpackChunkName: "event" */ './display/control.vue'),
        },
        {
          path: 'export',
          name: 'event.discipline.export',
          component: () => import(/* webpackChunkName: "event" */ './export/export.vue'),
        },
      ]
    }
  ]
}

